import { Link } from 'react-router-dom';

const WEB_INITIAL_PLANS = [
  {
    plan: 'シンプルプラン',
    description: 'サロンプロフィールページ 1枚もの',
    price: '¥11,000',
    note: null,
    icon: 'ri-file-list-3-line',
    sampleUrl: 'https://zenwest-sample02.readdy.co',
  },
  {
    plan: '広告プラン',
    description: '広告用LP（集客に特化したランディングページ）',
    price: '¥33,000',
    note: null,
    icon: 'ri-megaphone-line',
    sampleUrl: null,
  },
  {
    plan: 'ベーシックプラン',
    description: 'サロン紹介とお申込みサイト作成（3〜5ページ）',
    price: '¥55,000',
    note: '追加1ページにつき ¥5,500',
    icon: 'ri-pages-line',
    sampleUrl: 'https://zenwest-sample01.readdy.co',
  },
];

export default function Pricing() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#0EA5E9] text-sm font-semibold tracking-wider uppercase mb-3">Pricing</p>
          <h2 className="text-4xl font-extrabold text-[#1A2332] mb-4">
            シンプルで分かりやすい料金
          </h2>
          <p className="text-lg text-gray-600">
            仕訳数・ご状況に合わせて変動します
          </p>
        </div>

        {/* ── 記帳代行サービス ── */}
        <div className="relative flex items-center gap-4 mb-10">
          <div className="flex-1 h-px bg-gray-200"></div>
          <div className="flex items-center gap-2 shrink-0 bg-white border border-gray-200 px-5 py-2 rounded-full">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-file-list-3-line text-[#0EA5E9]"></i>
            </div>
            <span className="text-sm font-bold text-[#1A2332]">記帳代行サービス</span>
          </div>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-20">
          {/* 完全丸投げプラン */}
          <div className="bg-white rounded-3xl border-2 border-[#0EA5E9] p-8 relative">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              <span className="bg-[#0EA5E9] text-white text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap">一番人気</span>
            </div>
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-[#1A2332] mb-1">完全丸投げプラン</h3>
              <p className="text-xs text-gray-500 mb-4">領収書を渡すだけ、入力はこちらが行います</p>
              <div className="flex items-end justify-center gap-1">
                <span className="text-5xl font-extrabold text-[#0EA5E9]">¥8,800</span>
                <span className="text-base text-gray-500 mb-1">〜/月（税込）</span>
              </div>
              <p className="text-xs text-gray-400 mt-1">仕訳数・ご状況に合わせて変動します</p>
            </div>
            <div className="space-y-3 mb-6">
              {[
                '領収書の整理・仕訳入力',
                '月次試算表の作成',
                'クラウド会計の操作サポート',
                'メール・LINEでの随時質問対応',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#0EA5E9] rounded-full shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <button onClick={scrollToContact} className="w-full bg-[#0EA5E9] text-white py-3 rounded-full font-semibold hover:bg-[#1A2332] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm">
              無料相談を予約する
            </button>
          </div>

          {/* セルフ入力サポートプラン */}
          <div className="bg-white rounded-3xl border border-gray-200 p-8">
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-[#1A2332] mb-1">セルフ入力サポートプラン</h3>
              <p className="text-xs text-gray-500 mb-4">入力はご自身で、確認・サポートをお任せ</p>
              <div className="flex items-end justify-center gap-1">
                <span className="text-4xl font-extrabold text-[#1A2332]">¥5,500</span>
                <span className="text-base text-gray-500 mb-1">〜/月（税込）</span>
              </div>
              <p className="text-xs text-gray-400 mt-1">仕訳数・ご状況に合わせて変動します</p>
            </div>
            <div className="space-y-3 mb-6">
              {[
                'クラウド入力内容の確認・アドバイス',
                '仕訳ルールの指導・レクチャー',
                '月1回の内容チェックレポート',
                'メール・LINEでの随時質問対応',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#1A2332] rounded-full shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <button onClick={scrollToContact} className="w-full bg-[#1A2332] text-white py-3 rounded-full font-semibold hover:bg-[#0EA5E9] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm">
              詳細をお問い合わせ
            </button>
          </div>
        </div>

        {/* ── ホームページ作成サービス ── */}
        <div className="relative flex items-center gap-4 mb-10">
          <div className="flex-1 h-px bg-gray-200"></div>
          <div className="flex items-center gap-2 shrink-0 bg-white border border-gray-200 px-5 py-2 rounded-full">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-global-line text-emerald-500"></i>
            </div>
            <span className="text-sm font-bold text-[#1A2332]">ホームページ作成サービス</span>
          </div>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-4">
          {/* シンプルプラン */}
          <div className="bg-white rounded-3xl border border-gray-200 p-8 flex flex-col">
            <div className="flex items-center justify-center w-11 h-11 bg-emerald-50 rounded-2xl mb-5 mx-auto">
              <i className="ri-file-list-3-line text-emerald-600 text-xl"></i>
            </div>
            <div className="text-center mb-5">
              <h3 className="text-lg font-bold text-[#1A2332] mb-1">シンプルプラン</h3>
              <p className="text-xs text-gray-500 mb-4">サロンプロフィールページ 1枚もの</p>
              <div className="flex items-end justify-center gap-1">
                <span className="text-4xl font-extrabold text-emerald-600">¥11,000</span>
              </div>
              <span className="text-sm text-gray-400">（税込・初期費用）</span>
            </div>
            <div className="space-y-2.5 mb-6 flex-1">
              {['1ページ完結のプロフィールサイト', 'スマートフォン対応', '最短1〜2週間で納品'].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-emerald-500 rounded-full shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <a
              href="https://zenwest-sample02.readdy.co"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-full text-center border-2 border-emerald-500 text-emerald-600 py-2.5 rounded-full font-semibold hover:bg-emerald-500 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-sm block"
            >
              見本サイトを見る
            </a>
          </div>

          {/* 広告プラン */}
          <div className="bg-white rounded-3xl border-2 border-[#1A2332] p-8 flex flex-col relative">
            <div className="flex items-center justify-center w-11 h-11 bg-[#1A2332]/10 rounded-2xl mb-5 mx-auto">
              <i className="ri-megaphone-line text-[#1A2332] text-xl"></i>
            </div>
            <div className="text-center mb-5">
              <h3 className="text-lg font-bold text-[#1A2332] mb-1">広告プラン</h3>
              <p className="text-xs text-gray-500 mb-4">集客に特化したランディングページ</p>
              <div className="flex items-end justify-center gap-1">
                <span className="text-4xl font-extrabold text-[#1A2332]">¥33,000</span>
              </div>
              <span className="text-sm text-gray-400">（税込・初期費用）</span>
            </div>
            <div className="space-y-2.5 mb-6 flex-1">
              {['広告向けLP（ランディングページ）', '申込み・予約フォーム設置', 'コンバージョン重視の設計'].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#1A2332] rounded-full shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <button onClick={scrollToContact} className="w-full bg-[#1A2332] text-white py-2.5 rounded-full font-semibold hover:bg-[#0EA5E9] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm">
              詳細をお問い合わせ
            </button>
          </div>

          {/* ベーシックプラン */}
          <div className="bg-white rounded-3xl border border-gray-200 p-8 flex flex-col">
            <div className="flex items-center justify-center w-11 h-11 bg-emerald-50 rounded-2xl mb-5 mx-auto">
              <i className="ri-pages-line text-emerald-600 text-xl"></i>
            </div>
            <div className="text-center mb-5">
              <h3 className="text-lg font-bold text-[#1A2332] mb-1">ベーシックプラン</h3>
              <p className="text-xs text-gray-500 mb-4">サロン紹介とお申込みサイト（3〜5ページ）</p>
              <div className="flex items-end justify-center gap-1">
                <span className="text-4xl font-extrabold text-emerald-600">¥55,000</span>
              </div>
              <span className="text-sm text-gray-400">（税込・初期費用）</span>
            </div>
            <div className="space-y-2.5 mb-6 flex-1">
              {['3〜5ページの複数ページ構成', '追加1ページにつき ¥5,500', '2〜4週間で納品'].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-emerald-500 rounded-full shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <a
              href="https://zenwest-sample01.readdy.co"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="w-full text-center border-2 border-emerald-500 text-emerald-600 py-2.5 rounded-full font-semibold hover:bg-emerald-500 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-sm block"
            >
              見本サイトを見る
            </a>
          </div>
        </div>

        {/* ドメイン注記 */}
        <div className="flex items-start gap-2.5 bg-gray-50 rounded-xl px-5 py-4 max-w-5xl mx-auto mb-16">
          <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-line text-gray-400"></i>
          </div>
          <p className="text-xs text-gray-500">自分専用のアドレス（独自ドメイン）を取得する場合は、別途ドメイン管理費として年間 ¥11,000〜 が必要です。</p>
        </div>

        <div className="text-center mt-2">
          <Link to="/pricing" className="inline-flex items-center gap-2 text-[#0EA5E9] font-bold hover:gap-4 transition-all duration-300 cursor-pointer text-base">
            <span>詳しい料金はこちら</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
